import { autoinject } from "aurelia-framework"

@autoinject
export class ClipboardCustomAttribute {
 
    constructor(private element: Element) {

    }

    attached() {
        // Loop over any child elements and disable the click events. For example if you put this on a button,
        // and then put a span / image icon it breaks the click event.
        Array.from(this.element.childNodes).forEach(e => {
            const style = (<HTMLElement>e).style;
            if (style) {
                style.pointerEvents = 'none';
            }
        });

        this.element.addEventListener('click', this.handleClick);
    }

    detached() {
        this.element.removeEventListener('click', this.handleClick);
    }

    private handleClick($event: Event) {
        const srcElement = <Element>$event.srcElement;
        const text = srcElement.getAttribute('text');
        if (document.queryCommandSupported('copy') && text) {
            const hiddenElement: HTMLTextAreaElement = document.createElement('textarea');
            hiddenElement.style.display = 'none !important;';
            hiddenElement.innerText = text;

            document.body.appendChild(hiddenElement);
            hiddenElement.select();

            document.execCommand('SelectAll');
            document.execCommand('Copy');

            document.body.removeChild(hiddenElement);
        }
    }

    private valueChanged(newValue: string) {
        this.element.setAttribute('text', newValue);
    }
}